var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.74015 6.44781L14.8001 6.3934L14.7389 1.33008M14.1098 6.407C13.7437 5.03833 12.9448 3.82476 11.8323 2.94749C10.7197 2.07023 9.35332 1.57632 7.93701 1.53951C6.5207 1.5027 5.13047 1.92497 3.97389 2.74326C2.81731 3.56156 1.95641 4.73198 1.51974 6.0798C1.08307 7.42761 1.09404 8.88051 1.55102 10.2216C2.008 11.5626 2.88647 12.7199 4.05528 13.5207C5.22409 14.3214 6.62054 14.7226 8.03613 14.6644C9.45172 14.6062 10.8105 14.0917 11.9097 13.1978",
    stroke: "black",
    strokeWidth: 1.04991,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReload);
export default __webpack_public_path__ + "static/media/Reload.21080dfcc6fc2754ece244a9e0d10792.svg";
export { ForwardRef as ReactComponent };